module.exports = __webpack_public_path__ + "ddc3cc593c55ddb065c162bdb8414c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/racism-joey.jpg
// module id = 594
// module chunks = 0